import * as hmiclientbase from '../hmiclientbase';
import { prefbase } from '../hmiclientbase';

export const Pole = {
    AddContextTag: function (item: string, x: number, y: number) {
        let fieldNameElement = document.createElement('div');
        fieldNameElement.id = 'menucontext';
        fieldNameElement.className = 'pole_menu_context';
        fieldNameElement.style.top = y.toString() + 'px';
        fieldNameElement.style.left = x.toString() + 'px';

        let IdTrend = '';

        let tag: any = item.split('/');
        tag = tag[tag.length - 1];

        let configarch = window.GetArchiveConfig();
        for (let paramarch in configarch) {
            if (paramarch.indexOf(tag) == 0) {
                IdTrend = configarch[paramarch].SettingsGroups[0].Group;
                break;
            }
        }

        let menu = `
            <nav class="pole-menu">
                <ul class="pole-menu__items">
                    <li class="pole-menu__item pole-menu__header">
                        <i class="fa fa-item">${tag}</i>
                    </li>
                    <hr class="pole-menu__line">
                    <li class="pole-menu__item" id="search3D">
                        <i class="fa fa-tuning">3D Search</i>
                    </li>
                </ul>
            </nav>
        `;

        fieldNameElement.innerHTML = menu;

        const openFaceplateElement = fieldNameElement.querySelector('.pole-menu__item#openTrend');
        if (openFaceplateElement) {
            openFaceplateElement.addEventListener('click', (e) => {
                window.OpenMnemo(`Trends?Id=${IdTrend}&SELECT=${tag}`, 'Special');
            });
        }

        const search3DElement = fieldNameElement.querySelector('.pole-menu__item#search3D');
        if (search3DElement) {
            search3DElement.addEventListener('click', () => {
                hmiclientbase.SettingsGetObjectDto('ade8f6d3-fe5e-406c-bf75-6825885a9b92').then((obj) => {
                    const id = obj.parameters['SEARCH_TAG_3D'].id;
                    if (id) {
                        let value;
                        if (!item.includes(prefbase)) {
                            value = `${prefbase}/MODEL/${tag}`;
                        } else {
                            value = item;
                        }
                        hmiclientbase.SettingsChangeProperty(id, 'CV', value);
                    }
                });
            });
        }

        document.body.appendChild(fieldNameElement);
        return true;
    }
};
